import React from 'react';
import { Box, Card, CardContent, Typography, TextField, Grid, Button, Link } from '@mui/material'
import { Container, Form } from 'react-bootstrap'
import { useHistory, Redirect } from "react-router-dom";
import { useStyles as useStylesBase } from '../../constants/useStyles';
import ButtonLoading from '../../components/ButtonLoading';
import TextFieldValidate from '../../components/TextFieldValidate';
import { isEmail } from '../../utils/validator'
import config from '../../constants/config';

import { AxiosInstance } from '../../utils/RequestMethods';
import { naviagte } from '../../utils/utilsT';
import FormVerifyResetPassword from './FormVerifyResetPassword';
export type IForgotPasswordProps = {

}

const ForgotPassword: React.FC<IForgotPasswordProps> = (props) => {
  const [email, setEmail] = React.useState("");
  const classesBase = useStylesBase()
  const [validated, setValidated] = React.useState(false);
  const [completedRequest, setCompletedRequest] = React.useState(false);
  const [hash, setHash] = React.useState("");
  let history = useHistory()


  const submit = async (e): Promise<string> => {
    e.preventDefault();
    setValidated(true)
    if (email == "" || !isEmail(email)) {
      throw new Error("Make sure to input correct email.")
    }
    try {

      let params = {
        email: email,
        platform: "web",
      }
      return await AxiosInstance.post(`${config.url.token}/password/lost`, params).then((res) => {
        if (res && res.data) {
          console.log("res.data", res.data)
          setCompletedRequest(true)
        }
        return `Check ${email} for an email to reset your password. `
      })

    } catch (error) {
      throw error
    }
  }

  if (completedRequest ) {
    return <FormVerifyResetPassword
      email={email}
    />
  }

  return (
    <Container style={{ marginTop: "10vh", marginBottom: "10vh" }}>
      <Box className=" d-flex  justify-content-center  mb-2">
        <Card className="  col-md-8" style={{}}>
          <CardContent>
            <Form validated={validated} noValidate onSubmit={submit} style={{ padding: "20px" }} >
              <Typography variant='h5' className='mb-3' style={{}} >Forgot Password?</Typography>
              <Grid container spacing={3} className="mt-4">
                <Grid item xs={12}>
                  <TextFieldValidate

                    fullWidth
                    required
                    variant="standard"
                    autoComplete={'off'}
                    name="email"
                    label="Email"
                    type="email"
                    InputProps={{
                      // disableUnderline: true,
                    }}
                    value={`${email}`}
                    onChange={(event: any) => {
                      let value = event.target.value
                      setEmail(value)
                    }}
                    validated={validated}
                    onValidateError={(value) => {
                      if (value == "") {
                        return "Email is required."
                      }
                      if (!isEmail(value)) {
                        return "Invalid email"
                      }
                      return ""
                    }}
                  />

                </Grid>
                <Grid item xs={12}>

                  <ButtonLoading
                    customButton={Button}
                    customButtonProps={{
                      fullWidth: true,
                      variant: "contained",
                      color: "success",
                      size: "large"
                    }}

                    type="submit"
                    onClickFetching={submit}>
                    <Typography variant='h6' >Reset Password</Typography>
                  </ButtonLoading>
                </Grid>
                <Grid item xs={12}>
                  <Box display={"flex"} >


                    <Link className="ml-2" href="/login"
                      onClick={(e) => {
                        e.preventDefault()
                        naviagte(history, "login")
                      }}>Back to Login</Link>
                  </Box>
                </Grid>
              </Grid>
            </Form>
          </CardContent>
        </Card>
      </Box>
    </Container >
  );
}
export default ForgotPassword
